import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const usePurchaseProtectionMessagingExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.PurchaseProtectionMessaging,
        AmplitudeVariants.PurchaseProtectionMessaging.Treatment
    );
